import { render } from "./TokenOutput.vue?vue&type=template&id=03d3687e"
import script from "./TokenOutput.vue?vue&type=script&lang=ts"
export * from "./TokenOutput.vue?vue&type=script&lang=ts"

import "./TokenOutput.vue?vue&type=style&index=0&id=03d3687e&lang=css"
script.render = render

export default script